export default __webpack_public_path__ + "static/media/photo--sm--alaina-2.e8b1db70.jpg";